import React, { useEffect, useRef } from "react";
import "./style.scss";

import AboutBG from "./img/about-banner-bg.jpg";
import cohortImg from "./img/cohort-img.png";
// import createCohort from "./img/create-a-cohort.png";
import createCohort from "../../../.././assets/images/Purple button Rectangle.svg";

// import hostCohort from "./img/host-a-cohort.png";
import hostCohort from "../../../.././assets/images/Blue_Button_Rectangle.svg";
import { useHistory } from "react-router-dom";
import swal from "sweetalert";
import HTMLReactParser from "html-react-parser";
import { useTranslation } from "react-i18next";
import { PRODUCTION_MOVE_HIDDEN } from "../../../common/constants/actionConstants";
export default function IntroCohort(props) {
  const loginDataJson = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const frompagevariableintrocohort = props.fromPage;
  const pushbtnviewcohort = useRef();
  // useEffect(() => {
  //   if (
  //     frompagevariableintrocohort &&
  //     frompagevariableintrocohort === "mentorDashboard"
  //   ) {

  //     props.pushbtnviewcohort?.current &&
  //       props.pushbtnviewcohort?.current.click();
  //   } else {
  //   }
  // }, []);
  // if (
  //   frompagevariableintrocohort &&
  //   frompagevariableintrocohort === "mentorDashboard"
  // ) {

  // }
  if (
    frompagevariableintrocohort &&
    frompagevariableintrocohort === "mentorDashboard"
  ) {
    pushbtnviewcohort?.current?.scrollIntoView();
  }
  useEffect(() => {
    if (
      frompagevariableintrocohort &&
      frompagevariableintrocohort === "mentorDashboard"
    ) {
      pushbtnviewcohort?.current?.scrollIntoView();
    }
  }, []);

  const cohortRole = loginDataJson?.role;
  const { t } = useTranslation();
  const history = useHistory();
  const handleLoginClick = () => {
    localStorage.setItem("path", "path");
    history.push({
      pathname: "/cohort-form",
      state: {
        data: loginDataJson,
        fromPage: "cohort-program",
        mode: "create",
      },
    });
    // alert("abc");
  };
  const Banner = props.data[0];
  const BannerImage = Banner.BannerImage;
  const BannerTitle = Banner.BannerTitle;
  const BannerSubtitle = Banner.BannerSubtitle;

  const clickedOffline = () => {
    // let value = localStorage.getItem("SavedLoggedInData");
    // //
    // let Data = JSON.parse(value);
    //

    history.push({
      pathname: "/login",
      state: { role: "mentor" },
    });
  };

  return (
    <div className="intro-cohort">
      <section id="banner">
        <div class="w-100 pt-50 pb-0 position-relative">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-12 col-lg-6 wow slideInLeft">
                <div
                  class="mckp-img text-center tilt w-100"
                  data-max_tilt="10"
                  data-perspective="1000"
                  data-scale="1"
                  data-speed="700"
                >
                  <img class="img-fluid" src={BannerImage} alt="" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-lg-6 wow slideInRight">
                <div
                  class="content homepageFirstHeader homepageFirstDescription"
                  style={{
                    fontSize: "20px",
                    textAlign: "justify",
                    lineHeight: "25px",
                  }}
                >
                  {HTMLReactParser(BannerTitle)}
                  <br />
                  {HTMLReactParser(BannerSubtitle)}
                  <div className="get-mentor">
                    <div
                      className="cohort-Application top-btn mainfirstcohortbtndiv newuserTooltip"
                      onClick={() => {
                        if (PRODUCTION_MOVE_HIDDEN) {
                          swal(
                            "Please stay tuned, this function will be enabled shortly after the launch of Cohort onboarding process",
                            { closeOnClickOutside: false }
                          );
                        } else {
                          !cohortRole
                            ? clickedOffline()
                            : cohortRole && cohortRole != "Mentor"
                            ? swal(
                                "Retry",
                                " Only Mentor can Create a Cohort, " +
                                  "Please login with Mentor Credentials.",
                                // "success",
                                { closeOnClickOutside: false }
                              )
                            : handleLoginClick();
                        }
                      }}
                    >
                      <img
                        height="auto"
                        className=""
                        //   onClick={() => swal("Please stay tuned, this function will be enabled shortly after the launch of Cohort onboarding process",
                        //   {closeOnClickOutside: false}
                        // )
                        // //  handleLoginClick("Startup")
                        // }
                        src={createCohort}
                        alt="Slide 1 Mockup 6"
                      />
                      <div
                        className="centred mainfirstcohortbtn"
                        style={{ left: "48%" }}
                      >
                        Create
                        <br /> A Cohort
                      </div>
                      <span
                        className="tooltiptext  tooltip-bottom"
                        style={{
                          left: "76px",
                          top: "95px",
                          width: "auto",
                          padding: "0px 12px",
                        }}
                      >
                        Click to Create A Cohort
                      </span>
                    </div>
                    {/* <!-- banner btn --> */}
                    <div class="header-cart-box-banner-btn position-relative d-inline-block mainsecondcohortbtndiv">
                      <div class="tp-caption cart-btn position-relative cohort-Application top-btn">
                        <img height="auto" src={hostCohort} alt="" />
                        <div
                          className="centred mainsecondcohortbtn"
                          style={{ left: "48%" }}
                        >
                          Can I<br />
                          Host A Cohort
                        </div>
                      </div>
                      <div class="minicart-dropdown-banner-btn">
                        <p
                          style={{ cursor: "default", textAlign: "left" }}
                          class="banner-btn"
                        >
                          <a>
                            {t("ORGANIZATIONS")}
                            {/* ORGANIZATIONS */}
                          </a>
                        </p>
                        <p class="text-left">
                          {t("Cohort_category_applications_will_be_enabled")}
                          {/* Cohort category applications will be enabled only for
                          associations, special bodies, accelerators, and
                          incubators that are assisting entrepreneurs on
                          voluntary basis (pro-bono only). */}
                        </p>
                        <p class="banner-btn">
                          <a>
                            {t("INDIVIDUAL_MENTORS")}
                            {/* INDIVIDUAL MENTORS */}
                          </a>
                        </p>
                        <p class="text-left">
                          {t("group_of_mentors_can_participate_together")}
                          {/* A group of mentors can participate together by
                          offering a Cohort-based Program on the portal. The
                          cohort-based programs will allow a dedicated program
                          to be hosted for a definite time. */}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {props.fromPage && props.fromPage === "mentorDashboard" && ( */}
        <a
          className={"col-md-12  btn btn-primary "}
          style={{
            marginTop: "-37%",
            cursor: "pointer",
            height: "fit-content",
            textDecoration: "none",
            background: "transparent",
            // display: "none",
          }}
          // ref={pushbtnviewcohort}
          href="#viewallcohortsdiv"
        >
          {/* City Level */}
        </a>
        {/* )} */}
      </section>
      <div ref={pushbtnviewcohort} id="viewallcohortsdiv"></div>
    </div>
  );
}
